// extracted by mini-css-extract-plugin
export var csatScore = "_hp-5";
export var header = "_hp-1";
export var panelWrapper = "_hp-2";
export var postPreview = "_hp-3";
export var rightContent = "_hp-0";
export var wrappingText = "_hp-4";